import styled, { isTrellisTheme } from 'foundations-theming/utils';
import { devices } from 'signup-constants/styles/viewports.styles';
import { AnimatedButton } from 'signup-components/styles/ButtonAnimations.styles';
import { getStepConfig } from '../views/getStepConfig';
import { isLeftAlignedLayout } from '../utils/isLeftAlignedLayout';
const getButtonColumnCountEmbedded = currentStep => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  return stepButtonColumnConfig && stepButtonColumnConfig.embedded ? stepButtonColumnConfig.embedded : 1;
};
const getButtonColumnCountDesktop = (currentStep, isEmbedded) => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  if (isEmbedded) {
    return getButtonColumnCountEmbedded(currentStep);
  }
  return stepButtonColumnConfig ? stepButtonColumnConfig.default : 2;
};
const getButtonColumnCountMobile = (currentStep, isEmbedded) => {
  const stepConfig = getStepConfig(currentStep);
  const stepButtonColumnConfig = stepConfig && stepConfig.stepToButtonColumn;
  if (isEmbedded) {
    return getButtonColumnCountEmbedded(currentStep);
  }
  return stepButtonColumnConfig && stepButtonColumnConfig.mobile ? stepButtonColumnConfig.mobile : 1;
};
export const getButtonColumnCount = (currentStep, isMobile, isEmbedded) => {
  if (isMobile) {
    return getButtonColumnCountMobile(currentStep, isEmbedded);
  }
  if (isEmbedded) {
    return getButtonColumnCountEmbedded(currentStep);
  }
  return getButtonColumnCountDesktop(currentStep, isEmbedded);
};
export const ButtonsGridStyled = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridStyled"
})(["--column-count:", ";max-width:800px;@media ", "{", "}@media ", "{--column-count:", ";", "}--total_columns:calc(var(--column-count) * 2);--span:calc(var(--total_columns) / var(--column-count));display:grid;grid-template-columns:repeat(var(--total_columns),minmax(0,1fr));grid-auto-rows:auto;grid-gap:16px;& > *{grid-column:span var(--span);", "}padding-top:20px;@media ", "{padding-top:0px;}"], props => props.$columnCount || getButtonColumnCountMobile(props.$currentStep, props.embedded), devices.tablet, props => `--column-count: ${props.$columnCount || getButtonColumnCountDesktop(props.$currentStep, props.embedded)};`, devices.desktop, props => props.$columnCount || getButtonColumnCountDesktop(props.$currentStep, props.embedded), props => isLeftAlignedLayout(props.$layoutType) && (getButtonColumnCountDesktop(props.$currentStep, props.embedded) === 1 || props.$columnCount === 1) && `width: 420px;`, props => props.$shouldCenter && `	&:nth-last-child(${props.$offset}):nth-child(${props.$nthChild}) {
			grid-column: var(--span) / span var(--span);
		}`, devices.tablet);
export const ButtonsGridButtonHolder = styled.div.withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButtonHolder"
})(["min-height:", ";min-width:0;display:grid;@media ", "{max-width:400px;}"], ({
  minHeight
}) => minHeight || '5rem', devices.desktop);
export const ButtonsGridButton = styled(AnimatedButton).withConfig({
  displayName: "ButtonsGridstyles__ButtonsGridButton"
})(["height:100%;p{font-size:17px;font-weight:400;}@media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}@media ", "{p{font-size:17px;}&:focus{outline:none;box-shadow:0 0 0 2px ", ";}}"], devices.desktop, ({
  theme
}) => theme.color['do-not-use-calypso-medium'], devices.tablet, ({
  theme
}) => theme.color['do-not-use-calypso-medium']);
export const StyledIllustrationContainer = styled.div.withConfig({
  displayName: "ButtonsGridstyles__StyledIllustrationContainer"
})(["text-align:center;margin-top:20px;padding-top:10px;min-width:90px;min-height:90px;"]);
export const StyledButtonText = styled.p.withConfig({
  displayName: "ButtonsGridstyles__StyledButtonText"
})(["margin:0 !important;", " ", " ", ""], ({
  theme
}) => isTrellisTheme(theme) && `color: ${theme.color['text-core-default']} !important;`, props => props.isHubletButtonText && `padding-top: 5px; text-align: left;`, ({
  theme
}) => `font-weight: ${theme.typography['body-125'].fontWeight} !important;
    font-size: ${theme.typography['body-125'].fontSize} !important;`);